import useEthicsForm from './useResearcherForm'
//View
export type ResearcherFormView = ReturnType<typeof useEthicsForm> & {
    disabled?: boolean
    isDisableRIB?: boolean
    isDisablePhase?: boolean
    isDisableNumPhase?: boolean
    isShowNeedEditForm?: boolean
} & ResearcherFormType

//Controller
export type ResearcherFormType = {
    disabled?: boolean
    callbackChangeFaculty?: (irb?: string) => void
    isNotCompleteDocument?: boolean
    isDisableRIB?: boolean
    isDisablePhase?: boolean
    isDisableNumPhase?: boolean
    callbackChangeResearcherType?: (val: string) => void
    isShowNeedEditForm?: boolean
    isDisableNeedEditForm?: boolean
    isEditAfterReview?: boolean
    headerLabel?: string
    hideAccordion?: boolean
}

//Model
export type UseResearcherFormType = Omit<ResearcherFormType, ''>

export type OptType = {
    label: string
    value: string
}
export type RadType = {
    id: string
    name: string
}

export enum ResearcherType {
    student = '1', // นิสิต/นักศึกษา
    teacher = '2', // นักวิจัย/อาจารย์
}
